import {o_shoppages} from './shoppages.js';

o_shoppages.layer = {
  init (): void {
    o_shoppages.accordion.init();
    o_shoppages.focussedDialog.init();
  }
};
